/* eslint-disable no-undef */
export default {
  api: process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_SERVER_URL}/api/v1` : '/api/v1',
  embedUrl: process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_SERVER_URL}/api/v1` : '/api/v1',
  fileServer: process.env.REACT_APP_FILE_SERVER_URL || '',
  KEYCLOAK_DOMAIN: process.env.REACT_APP_KEYCLOAK_DOMAIN || 'https://auth-staging.tingdev.tube',
  KEYCLOAK_CLIENT: process.env.REACT_APP_KEYCLOAK_CLIENT || 'ting-auth-service',
}
